import React from 'react';
import { CheckCircle2, CloudOff } from 'lucide-react';
import SyncIndicator from 'components/SyncIndicator';
import { ESTADO_ICONO, ESTADO_PILL } from 'lib/estadoUi';
import FranjaFalla from './FranjaFalla';

// Pantalla después de guardar. Sin conexión, la inspección queda en la cola
// del teléfono (en ámbar: todavía no llegó) y el indicador muestra cuántas
// faltan por enviar y cualquier rechazo de la base. Con alguna falla, la
// franja roja "no operar" queda arriba.
// correccion: { anulada, errorAnulacion, reintentando, onReintentar } cuando lo
// guardado es una corrección (va en línea, nunca por la cola).
export default function PantallaFinal({ offline, fallas = 0, nombreInstalacion, correccion }) {
  const Icono = offline ? CloudOff : CheckCircle2;
  const AlertaIcono = ESTADO_ICONO.alerta;
  let titulo;
  let texto;
  if (correccion) {
    titulo = 'Corrección guardada';
    texto = correccion.anulada
      ? 'Quedó registrada y la inspección original quedó anulada con el motivo.'
      : 'Quedó registrada como corrección de la inspección original.';
  } else if (offline) {
    titulo = 'Guardada sin conexión, se sincronizará cuando haya señal';
    texto = 'Quedó guardada en este teléfono y todavía no llegó a administración. Se enviará sola cuando vuelva la señal.';
  } else {
    titulo = 'Inspección guardada';
    texto = 'Quedó registrada. Gracias.';
  }
  return (
    <div className="flex flex-col items-center pt-10 text-center">
      <span
        className={`flex h-20 w-20 items-center justify-center rounded-full border-2 ${
          offline ? ESTADO_PILL.alerta : ESTADO_PILL.aprobado
        }`}
      >
        <Icono size={44} strokeWidth={2.25} aria-hidden="true" />
      </span>
      <h2 tabIndex={-1} className="mt-5 text-2xl font-bold leading-tight text-foreground focus:outline-none">
        {titulo}
      </h2>
      <p className="mt-3 max-w-sm text-base text-foreground">{texto}</p>
      {fallas > 0 ? (
        <div className="w-full">
          <FranjaFalla fallas={fallas} nombreInstalacion={nombreInstalacion} />
        </div>
      ) : null}
      {correccion && !correccion.anulada ? (
        <div role="alert" className={`mt-5 w-full rounded-2xl border-2 p-4 text-left ${ESTADO_PILL.alerta}`}>
          <p className="flex items-start gap-2 text-base font-bold text-foreground">
            <AlertaIcono size={20} className="mt-0.5 shrink-0" aria-hidden="true" />
            <span>La corrección quedó guardada, pero la inspección original sigue vigente.</span>
          </p>
          {correccion.errorAnulacion ? (
            <p className="mt-1 text-base text-foreground">{correccion.errorAnulacion}</p>
          ) : null}
          <p className="mt-1 text-base text-foreground">
            Hasta anularla, las dos cuentan en el historial. Intente de nuevo; si sigue fallando, anúlela desde su detalle.
          </p>
          <button
            type="button"
            onClick={correccion.onReintentar}
            disabled={correccion.reintentando}
            className="mt-3 min-h-[48px] rounded-xl bg-foreground px-4 text-base font-semibold text-white disabled:opacity-60"
          >
            {correccion.reintentando ? 'Anulando…' : 'Reintentar anular la original'}
          </button>
        </div>
      ) : null}
      {correccion ? null : (
        <div className="mt-5 w-full">
          <SyncIndicator />
        </div>
      )}
    </div>
  );
}
